module.exports = __webpack_public_path__ + "static/media/phoneIcon.606a3258.svg";